import styled from "styled-components";
import { List } from "semantic-ui-react";

export const StyledListHeader = styled(List.Header)`
  color: #fff;
  font-weight: bold;
  font-family: "Lato", sans-serif;
`;

export const StyledListDesc = styled.div`
  color: #9ab;
  font-family: "Lato", sans-serif;
`;
